import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';

import { NotificationDialogComponent } from '../components/notification-dialog/notification-dialog.component';

@Injectable()
export class NotificationDialogService {
  constructor(private dialog: MatDialog) { }

  public openNotificationDialog(ids: number[]): void {
    if(!ids || ids.length === 0) { return; }
    this.dialog.open(NotificationDialogComponent, {
      data: { userIds: ids },
      width: '800px',
    });
  }
}
